import { useI18n } from '../i18n/context.js';
import { Icon } from './Icon.js';

const DESIGN_TOOLS = [
  { name: 'Figma', url: 'https://www.figma.com', icon: '🎨' },
  { name: 'Canva', url: 'https://www.canva.com', icon: '🖼' },
  { name: 'Adobe Express', url: 'https://express.adobe.com', icon: '✨' },
  { name: 'Excalidraw', url: 'https://excalidraw.com', icon: '✏️' },
  { name: 'tldraw', url: 'https://tldraw.com', icon: '🗒' },
];

/** Design section: links to popular design tools. */
export function DesignScreen() {
  const { t } = useI18n();

  return (
    <div className="design-screen">
      <p className="design-subtitle">{t('design.subtitle')}</p>
      <div className="design-tool-list">
        {DESIGN_TOOLS.map((tool) => (
          <a
            key={tool.name}
            href={tool.url}
            target="_blank"
            rel="noopener noreferrer"
            className="design-tool-item card"
          >
            <span className="design-tool-icon" aria-hidden="true">{tool.icon}</span>
            <span className="design-tool-name">{tool.name}</span>
            <Icon name="external" size={16} className="design-tool-ext" />
          </a>
        ))}
      </div>
    </div>
  );
}
